import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import { Notification } from "@/types/notification.ts";

const NotificationCard = ({ notification }: { notification: Notification }) => {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{notification.title}</CardTitle>
        <CardDescription>{notification.message}</CardDescription>
      </CardHeader>
      <Separator />
      <CardFooter>
        <div className="w-full text-xs">
          <span>
            {new Date(notification.created_at).toLocaleString("en-US", {})}
          </span>
        </div>
      </CardFooter>
    </Card>
  );
};

export default NotificationCard;
